module.exports = __webpack_public_path__ + "img/react.33170016.png";